<template>
    <div>
        <div class="archive-table">
            <el-form size="mini" :inline="true" style="margin-top: -10px;">
                <el-row >
                    <el-form-item v-if="isShowSwitch">
                        <el-switch
                            v-model="isShowTree"
                            active-color="#ff4949"
                            inactive-color="#13ce66"
                            active-text="档案目录"
                            inactive-text="文件列表"
                            @change="changeSwitch"
                            >
                        </el-switch>
                    </el-form-item>
                </el-row>
                <el-row >
                    <!-- <el-col :span="5">
                      <el-form-item v-if="isShowSwitch">
                              <el-switch
                                  v-model="isShowTree"
                                  active-color="#ff4949"
                                  inactive-color="#13ce66"
                                  active-text="档案目录"
                                  inactive-text="文件列表"
                                  @change="changeSwitch"
                                  >
                              </el-switch>
                      </el-form-item>
                    </el-col> -->
                    <el-col :span="isShowSwitch?9:10">
                        <el-form-item v-if="isShowTree" label="审核状态">
                            <el-select style="width:120px;" v-model="searchParam.approvalStatus" @change="handleViewTemplate" placeholder="请选择">
                                <el-option
                                    v-for="item in approvalStatusArr"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item v-if="isShowTree" label="档案编号">
                          <el-input maxlength="60" placeholder="请输入档案编号" v-model="processInstanceArchiveNo">
                              <el-button type="primary" slot="append" title='修改档案编号' icon="el-icon-edit" @click="handleSaveArchiveNo"></el-button>
                          </el-input>
                        </el-form-item> -->
                    </el-col>
                    <el-col v-if="isShowTree" :span="isShowSwitch?10:14" style="float: right;">
                        <el-button class='print-class back-class' icon="el-icon-top"  v-if="!isApply&&!isNewPage"  title='返回上一页' type="warning" size="mini"  @click.stop="handleGoArchiveNav()">返回</el-button>
                        <el-button class='print-class' v-if="!isFullScreen" type="primary" icon="el-icon-rank"  size="mini" @click.stop="handleFullScreen()">全屏</el-button>
                        <el-button class='print-class' type="primary" icon="el-icon-printer" size="mini" @click.stop="archiveDirExport()">导出目录</el-button>
                        <!-- <el-button class='print-class' type="primary" icon="el-icon-printer" size="mini" @click.stop="handlePrint()">打印</el-button> -->
                        <el-button class='print-class' v-permission="permission.archiveApprovalBtn"  v-if="!isApply" title='对全部文档进行归档审批' type="primary" size="mini" icon="el-icon-info"  @click.stop="handleAllApprovalFiles()">一键审核</el-button>
                        <el-button class='print-class' v-if="isApply" title='对全部文档发起归档申请' type="warning" size="mini" icon="el-icon-star-on"  @click.stop="handleAllApplyFiles()">一键归档</el-button>
                        <!-- <el-button class='print-class' v-if="isApply" title='将文件列表里打过标签的文件归集到对应的档案目录下' type="primary" size="mini" icon="el-icon-star-on"  @click.stop="handleMergeFiles()">文件归集</el-button> -->
                        <!-- <div v-if="!isApply&&!isNewPage" style="cursor:pointer;font-size: 15px;margin-right: 18px;" @click.stop="handleGoArchiveNav()">
                            <span class="tag-link span-line">← 返回</span>
                        </div> -->
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div v-if="isShowTree" class="tree-node">
           <tree-table
              :ref="'archiveDetail'"
              :data="archiveTemplateTreeList"
              :isShowBtn="isShowBtn"
              :isShowCheckbox="false"
              :expandAll="true"
              :isApply="isApply"
              :columns="archiveTemplateTreeColumns"
              :templateId="templateId"
              :processInstanceId="processInstanceId"
              :tableStyle="tableStyle"
              :tbHeight="tbHeight"
              :isApprovalMode="isApprovalMode"
              @manageFolder="manageFolder"
              @getFileList="handleViewTemplate"
              @handleDownLoad="handleDownLoad"
              @previewFile="previewFile"
              @handleDelete="handleDelete"
              @handleApplyFiles="handleApplyFiles"
              @handleApprovalFiles="handleApprovalFiles"
              border/>
        </div>
        <div v-if="!isShowTree" class="tree-node">
           <ProcessFiles  bizType="process" :processInstanceId="processInstanceId" :isApprovalMode="isApprovalMode" :isShowBackBtn="isShowBackBtn" :templateId="templateId" />
        </div>
        <el-dialog
              custom-class="task-edit-dialog"
              :title="folderTitle"
              :visible.sync="isShowFolder"
              top="4vh"
              width="70%"
              append-to-body
              >
                <el-form size="mini" label-width="120px">
                  <el-row v-if="isDir">
                      <el-form-item label="档案盒编号">
                        <el-input placeholder="请输入档案盒编号" v-model="folderObj.archiveNo"></el-input>
                      </el-form-item>
                  </el-row>
                  <el-row v-if="isDir">
                      <el-form-item label="存放位置">
                        <el-input placeholder="请输入存放位置" v-model="folderObj.fileLocation"></el-input>
                      </el-form-item>
                  </el-row>
                   <el-row>
                        <el-form-item label="上级目录">
                          <el-input disabled="disabled" v-model="pDirectory"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row v-if="isDir">
                        <el-form-item label="序号">
                          <el-input :disabled="isdisabled" v-model="folderObj.orderNum"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item v-if="isDir" label="文件夹名称">
                          <el-input :disabled="isdisabled" placeholder="文件夹名称" v-model="folderObj.label"></el-input>
                        </el-form-item>
                        <el-form-item v-else label="文件名称">
                          <el-input disabled="disabled" v-model="folderObj.label"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row v-if="isDir">
                        <el-form-item  label="是否需要">
                            <el-radio :disabled="isdisabled" v-model="folderObj.need" :label="true">应</el-radio>
                            <el-radio :disabled="isdisabled" v-model="folderObj.need" :label="false">宜</el-radio>
                        </el-form-item>
                    </el-row>
                     <el-row>
                        <el-form-item label="资料形式">
                           <el-checkbox-group  v-if="isDir" :disabled="isdisabled" v-model="checkboxSelected">
                             <el-checkbox v-for="obj in checkboxArr"  :key="obj.index" :label="obj.label" >{{obj.name}}</el-checkbox>
                           </el-checkbox-group> 
                           <el-checkbox-group  v-else v-model="checkboxSelected">
                             <el-checkbox v-for="obj in checkboxArr"  :key="obj.index" :label="obj.label" >{{obj.name}}</el-checkbox>
                           </el-checkbox-group> 
                        </el-form-item>
                    </el-row>
                    <el-form-item label="备注说明">
                        <el-input  v-if="isDir" :disabled="isdisabled" type="textarea" :rows="3" placeholder="请输入内容" v-model="folderObj.remarks" />
                        <el-input  v-else type="textarea" :rows="3" placeholder="请输入内容" v-model="folderObj.remarks" />
                    </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowFolder = false">取 消</el-button>
                  <el-button type="primary" :loading="!isShowFolder" @click="handleAddFolder">保存</el-button>
              </span>
          </el-dialog>

          <el-dialog
              title="文件归集"
              top="2vh"
              :fullscreen = true
              :visible.sync="isShowApprovalFilesDialog"
              append-to-body
              >
              <div class="introduce">
                  <el-row>
                      <el-popover
                          placement="bottom-start"
                          title="文件归集说明："
                          width="230"
                          trigger="hover"
                          content="该功能是将打过标签的文件先进行归集，方便进行归档处理。1.在文件列表对文件进行标签设置 2.设置的标签对应到档案目录 3.进行文件归集时，会自动将标签对应的档案目录下的文件归集到档案管理列表。">
                          <el-button slot="reference">使用说明</el-button>
                      </el-popover>
                    </el-row>
                </div>
              <el-form style="height:400px" size="mini" label-width="120px">
                  <el-row>
                      <el-form-item label="待归集目录">
                          <el-input  disabled v-model="mergeFilesDirName" />
                      </el-form-item>
                  </el-row>
                  <el-row>
                      <el-form-item label="档案目录">
                          <TreeSelect
                              ref="selectMultipleFiles"
                              :sourceOptions="archiveTemplateInstanceTreeList"
                              :disableBranchNodes="false"
                              @treeSelectChoose="approvalFilesSelectChoose"
                              :multiple="true"
                              :valueConsistsOf="valueConsistsOf"
                          />
                      </el-form-item>
                  </el-row>

              </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowApprovalFilesDialog = false" >取 消</el-button>
                  <el-button type="primary" @click="mergeFiles">文件归集</el-button>
              </span>
          </el-dialog>

           <el-dialog
            :title="approvalDialogTile"
            :visible.sync="isShowApprovalDialog"
            append-to-body
            >
                <el-form :model="approvalInfo" ref="approvalInfoForm" size="mini" label-width="120px">
                  <el-row>
                      <el-form-item label="档案目录名称" prop="archiveName" >
                        <el-input disabled="disabled" v-model="approvalInfo.archiveName"></el-input>
                      </el-form-item>
                  </el-row>
                  <el-row>
                      <el-form-item  label="审批结论">
                        <el-radio-group v-model="approvalInfo.status" size="mini" class="exec-type">
                          <el-radio :label="2">通过</el-radio>
                          <el-radio :label="3">驳回</el-radio>
                        </el-radio-group>
                      </el-form-item>
                  </el-row>
                  <el-row>
                      <el-form-item label="审批描述"  prop="approveDesc">
                        <el-input placeholder="请输入内容"  type="textarea" :autosize="{ minRows: 6, maxRows: 10}" v-model="approvalInfo.approveDesc"></el-input>
                      </el-form-item>
                  </el-row>
                </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowApprovalDialog = false">取 消</el-button>
                  <el-button type="primary" @click="handleFinalApproval" :loading="startProcessloading">确 定</el-button>
              </span>
          </el-dialog>
        <el-dialog 
            append-to-body
            top="3vh"
            width="95%"
            :visible.sync="dialogVisible">
            <div width="100%" style="text-align:center;">
            <img :src="dialogImageUrl" alt="" style="max-height:100%;max-width:100%;">
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import mixinsNav from '@/mixins/mixins-nav';
    import { API_IMG_DOWNLOAD, API_FILE_DOWNLOAD, API_EXPORT_ARCHIVE_DIR_EXCEL, API_ARCHIVE_FOLDER_FILE_DOWNLOAD, CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN } from '@/common/constants';
    import { addSaveArchiveNo, mergeArchiveFile, applyArchiveFile, approvalArchiveFile, addMoveArchiveFile, saveArchiveTemplateInstanceTree, saveArchiveInstanceFile, getArchiveTemplateFiles, deleteArchiveTemplateFile, getArchiveTemplateInstanceFiles, getArchiveTemplateInstanceTreeList, downloadFiles } from '@/data-model';
    import ProcessFiles from '@/pages/process/components/ProcessFiles';
    import TreeTable from '@/components/TreeTable';
    import { getPreviewFileUrl } from '@/utils/grocer';
    export default {
        mixins: [ mixinsNav ],
        components: {
            ProcessFiles,
            TreeTable
        },
        data () {
            return {
                dialogImageUrl: '',
                dialogVisible: false,
                approvalStatusArr: [{
                    value: 999,
                    label: '全部'
                }, {
                    value: 99,
                    label: '未归档'
                }, {
                    value: 1,
                    label: '审核中'
                }, {
                    value: 2,
                    label: '归档通过'
                }, {
                    value: 3,
                    label: '归档驳回'
                }],
                isShowTree: false, // 默认文件模式
                processInstanceArchiveNo: '',
                searchParam: {
                    approvalStatus: 1, // 待审核
                    templateId: '',
                    processInstanceId: '',
                    hasChildFiles: true
                },
                approvalInfo: {
                    templateId: '',
                    processInstanceId: '',
                    archiveFolderIds: '',
                    archiveName: '',
                    status: 2,
                    approveDesc: ''
                },
                startProcessloading: false,
                isShowApprovalDialog: false,
                approvalDialogTile: '档案审核',
                archiveTemplateInstanceTreeList: [],
                valueConsistsOf: 'ALL',
                mergeFilesDirId: '',
                mergeFilesDirName: '',
                isShowApprovalFilesDialog: false,
                nowPathKey: '', // 当前路径深度对应的key
                formList: [], // 列表数据
                currentPage: 1, // 当前页码
                pageSize: 20, // 每页条数
                totalPageNum: 1, // 总页数
                loading: false, // 列表的loading状态
                searchName: '', // 查询的关键字,
                isChooseFile: false,
                fileList: [],
                directoryList: [], // 文件夹目录导航栏
                treeId: '1', // 当前选中的树节点
                treeName: '456', // 当前选中的树节点名称
                selectTreeNode: {label: ''},
                // rootPath:'/document/archiveTemplate',
                fileListLength: 0,
                selectedCheckboxList: [],
                isShowDirectory: false,
                targetDirectoryId: '',
                targetDirectoryName: '',
                isShowFolder: false,
                isdisabled: '',
                isShowPreview: false,
                folderTitle: '',
                folderObj: {
                    id: '',
                    pId: '', // 上级节点
                    dir: true, // 是否文件夹
                    category: 1,
                    templateId: '', // 档案模板id
                    orderNum: '', // 序号
                    label: '', // 文件夹名称
                    remarks: '', // 备注说明
                    need: true, // 是否必须包含该类文件 0不必须  1必须
                    fileTypes: '', // 资料形式
                    original: false, // 原件
                    copy: false, // 复印件
                    scan: false, // 扫描件
                    electronic: false, // 电子版
                    fileId: '', // 文件id
                    createdBy: '',
                    archiveNo: '',
                    fileLocation: ''
                },
                checkboxSelected: [],
                isDir: false, // 是否文件夹
                checkboxArr: [
                    {index: 1, label: '1', name: '原件'},
                    {index: 2, label: '2', name: '复印件'},
                    {index: 3, label: '3', name: '扫描件'},
                    {index: 4, label: '4', name: '电子版'}
                ],
                archiveTemplateTreeList: [],
                tableStyle: 'width: 100%',
                archiveTemplateTreeColumns: [
                    {
                        text: '序号',
                        value: 'orderNum',
                        width: 145,
                        tdType: 'class java.lang.String',
                        fixed: true
                    }, {
                        text: '名称',
                        value: 'label',
                        width: 200,
                        tdType: 'class java.lang.String',
                        fixed: true
                    }, {
                        text: '备注说明',
                        value: 'remarks',
                        tdType: 'class java.lang.String',
                        width: 150
                    }, {
                        text: '是否需要',
                        value: 'isNeedView',
                        tdType: 'class java.lang.String',
                        width: 70
                    }, {
                        text: '原件',
                        value: 'isOriginalView',
                        tdType: 'class java.lang.String',
                        width: 60
                    }, {
                        text: '复印件',
                        value: 'isCopyView',
                        tdType: 'class java.lang.String',
                        width: 60
                    }, {
                        text: '扫描件',
                        value: 'isScanView',
                        tdType: 'class java.lang.String',
                        width: 60
                    }, {
                        text: '电子版',
                        value: 'isElectronicView',
                        tdType: 'class java.lang.String',
                        width: 60
                    }, {
                        text: '上传人',
                        value: 'uploadUser',
                        width: 60
                    }, {
                        text: '上传时间',
                        value: 'uploadTime',
                        width: 140
                    }, {
                        text: '归档状态',
                        value: 'approvalStatusView', // 0草稿 1审核中 2通过 3驳回
                        width: 70
                    }, {
                        text: '审批人',
                        value: 'approvaler',
                        width: 60
                    }, {
                        text: '审批时间',
                        value: 'approvalTime',
                        width: 140
                    }, {
                        text: '审批描述',
                        value: 'approveDesc',
                        width: 70
                    }, {
                        text: '档案盒编号',
                        value: 'archiveNo',
                        tdType: 'class java.lang.String',
                        width: 90
                    }, {
                        text: '存放位置',
                        value: 'fileLocation',
                        tdType: 'class java.lang.String',
                        width: 100
                    }
                ],
                pDirectory: '', // 当前父目录
                // key: true //单个点击直到全部选中
                permission: {
                    archiveApprovalBtn: [// 业务档案文件审核
                        CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN
                    ]
                }
            };
        },
        watch: {
            checkboxSelected (newVal, oldVal) {
                if (newVal) {
                    this.folderObj.original = false;
                    this.folderObj.copy = false;
                    this.folderObj.scan = false;
                    this.folderObj.electronic = false;
                    newVal.forEach(item => {
                        if (item === '1') {
                            this.folderObj.original = true;
                        } else if (item === '2') {
                            this.folderObj.copy = true;
                        } else if (item === '3') {
                            this.folderObj.scan = true;
                        } else if (item === '4') {
                            this.folderObj.electronic = true;
                        }
                    });
                }
            }
        },
        props: {
            isShowBackBtn: {// 显示返回上一页按钮
                type: Boolean,
                default: false
            },
            isApprovalMode: {// 审核模式
                type: Boolean,
                default: false
            },
            instancesInfo: {
                type: Object
            },
            isInstance: { // 是否为模板
                type: Boolean,
                default: false
            },
            templateId: { // 档案模板id
                type: String
            },
            processInstanceId: { // 流程实例id
                type: String
            },
            rootPath: { // 面包屑导航栏地址
                type: String,
                default: '/document/archiveTemplate'
            },
            isFullScreen: { // 是否全屏
                type: Boolean,
                default: true
            },
            tbHeight: {
                type: String,
                default: '400'
            },
            isShowBtn: {
                type: Boolean,
                default: false
            },
            isApply: {// 是否申请人模式
                type: Boolean,
                default: false
            },
            isShowSwitch: {// 是否需要切换查看
                type: Boolean,
                default: false
            },
            isNewPage: {
                type: Boolean,
                default: false
            }
        },
        filters: {// 如下这样写
            getfilesize: function (size) {
                // console.log(size);
                if (!size) {
                    return '';
                }
                var num = 1024.00; // byte
                if (size < num) { return size + '(B)'; }
                if (size < Math.pow(num, 2)) { return (size / num).toFixed(2) + '(K)'; } // kb
                if (size < Math.pow(num, 3)) { return (size / Math.pow(num, 2)).toFixed(2) + '(M)'; } // M
                if (size < Math.pow(num, 4)) { return (size / Math.pow(num, 3)).toFixed(2) + '(G)'; } // G
                return (size / Math.pow(num, 4)).toFixed(2) + '(T)'; // T
            }
        },
        created () {
            // this._initPage();
        },
        methods: {
            async _initPage () {
                // console.log(this.instancesInfo);
                this.processInstanceArchiveNo = this.instancesInfo.archiveNo ? this.instancesInfo.archiveNo : '';
                this.handleViewTemplate();
            },
            handleAddFolder () { // 保存文件夹
                if (this.folderObj.label.trim() === '') {
                    this.$message({message: '请输入文件夹名称', type: 'warning'});
                    return;
                }
                this.folderObj.templateId = this.templateId;
                this.folderObj.processInstanceId = this.processInstanceId;
                // console.log(this.folderObj);
                this.$confirm('您确定' + this.folderTitle + '吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    if (this.folderObj.dir) {
                        await saveArchiveTemplateInstanceTree(this.folderObj);// 保存文件夹信息
                        this.handleViewTemplate();
                    } else {
                        await saveArchiveInstanceFile(this.folderObj);// 保存文件信息
                        this.handleViewTemplate();
                    }
                    this.isShowFolder = false;
                }).catch(() => {});
            },
            manageFolder (row) {
                // console.log(row);
                this.folderObj.createdBy = row.createdBy;
                this.folderObj.dir = row.dir;
                this.folderObj.id = row.id;
                this.folderObj.pId = row.pId;
                this.pDirectory = row.pLabel;
                this.folderObj.templateId = row.templateId;
                this.folderObj.orderNum = row.orderNum;
                this.folderObj.label = row.label;
                this.folderObj.remarks = row.remarks;
                this.folderObj.need = row.need;
                this.folderObj.archiveNo = row.archiveNo;
                this.folderObj.fileLocation = row.fileLocation;
                if (row.dir) {
                    this.folderTitle = '修改档案目录';
                } else {
                    this.folderTitle = '修改文件信息';
                    this.folderObj.fileId = row.fileId;
                }
                let selected = [];
                if (row.original) {
                    selected.push('1');
                }
                if (row.copy) {
                    selected.push('2');
                }
                if (row.scan) {
                    selected.push('3');
                }
                if (row.electronic) {
                    selected.push('4');
                }
                this.checkboxSelected = selected;
                this.isDir = row.dir;
                if (this.isInstance) {
                    this.isdisabled = 'disabled';
                }
                this.isShowFolder = true;
            },
            async handleViewTemplate () {
                let treeList = [];
                this.searchParam.templateId = this.templateId;
                this.searchParam.processInstanceId = this.processInstanceId;
                treeList = await getArchiveTemplateInstanceTreeList(this.searchParam);
                if (treeList) {
                    this.archiveTemplateTreeList = treeList;
                }
                // console.log(treeList);
                this.isShowPreview = true;
            },
            handleDownLoad (row) { // 下载
                // console.log(row);
                if (row.filePath) {
                    let url = `${API_FILE_DOWNLOAD}${row.filePath}`;
                    this.download(url);
                }
            },
            download (url) {
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
                downloadFiles(url);
            },
            dleFolderDownLoad (row) {
                let url = `${API_ARCHIVE_FOLDER_FILE_DOWNLOAD}`;
                url = url.replace(':templateId', this.templateId).replace(':processInstanceId', this.processInstanceId).replace(':archiveFolderId', row.id).replace(':archiveFolderName', row.label);
                this.download(url);
            },
            async archiveDirExport () {
                let url = `${API_EXPORT_ARCHIVE_DIR_EXCEL}`;
                // console.log(JSON.stringify(this.archiveTemplateTreeColumns));
                // url = url.replace(':templateId', this.templateId).replace(':processInstanceId', this.processInstanceId).replace(':hasChildFiles', false).replace(':processInstanceArchiveNo', processInstanceArchiveNo);
                url = url.replace(':templateId', this.templateId).replace(':processInstanceId', this.processInstanceId).replace(':hasChildFiles', false).replace(':processInstanceName', this.instancesInfo.name).replace(':processInstanceArchiveNo', this.processInstanceArchiveNo ? this.processInstanceArchiveNo : '');
                this.download(url);
            },
            async previewFile (file) {
                let previewUrl = null;
                let directFileExtend = '.gif,.png,.jpg,.ico,.bmp,.pdf,.PDF';// 直接打开
                let filename = decodeURIComponent(file.fileName);
                let fileSuffix = filename.substring(filename.lastIndexOf('.')).toLowerCase();
                if (directFileExtend.indexOf(fileSuffix) > -1) {
                    this.handlePictureCardPreview(file);
                } else {
                    previewUrl = await getPreviewFileUrl(file);
                    if (previewUrl) {
                        let tempwindow = window.open();
                        tempwindow.location = previewUrl;
                        this.readFile(file);
                    }
                }
                // let previewUrl = await getPreviewFileUrl(file);
                // if (previewUrl) {
                //     let tempwindow = window.open();
                //     tempwindow.location = previewUrl;
                // }
            },
            handlePictureCardPreview (file) {
                this.dialogImageUrl = `${API_IMG_DOWNLOAD}${file.filePath}`;
                this.dialogVisible = true;
            },
            async handleDeleteBatch () { // 删除
                // let delfileIds = [];
                if (this.selectedCheckboxList.length === 0) {
                    this.$message({message: '请选择要删除的文件', type: 'warning'});
                    return;
                }
                this.$confirm('您确定要批量删除文件吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let delObj = {
                        processInstanceId: this.processInstanceId,
                        files: this.selectedCheckboxList
                    };
                    await deleteArchiveTemplateFile(delObj);
                    await this._initPage();
                });
            },
            handleDelete (row) { // 删除
                this.$confirm('您确定要删除文件【' + row.fileName + '】吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // let delObj = {
                    //   files:[row]
                    // };
                    let delObj = {
                        processInstanceId: this.processInstanceId,
                        files: [{id: row.id, category: row.category, templateId: row.templateId, createdBy: row.createdBy, approvalStatus: row.approvalStatus}]
                    };
                    await deleteArchiveTemplateFile(delObj);
                    await this._initPage();
                });
            },
            handleMove () { // 移动到
                // console.log("handleMove");
                setTimeout(() => {
                    this.$refs.treeChild._initPage();
                }, 0);
                this.isShowDirectory = true;
            },
            async handleSaveMove () {
                // console.log(this.selectedCheckboxList);
                // console.log(this.targetDirectoryId);
                // console.log(this.targetDirectoryName);
                this.isShowDirectory = false;
                this.$confirm('您确定要批量移动文件吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let moveObj = {
                        targetDirectoryId: this.targetDirectoryId,
                        sourceFiles: this.selectedCheckboxList,
                        isInstance: this.isInstance
                    };
                    await addMoveArchiveFile(moveObj);
                    await this._getFormData();
                });
            },
            async _getFormData () {
                this.loading = true;
                let formData = {};
                if (this.isInstance) {
                    formData = await getArchiveTemplateInstanceFiles({
                        currentPage: this.currentPage,
                        pageSize: this.pageSize,
                        fileName: this.searchName,
                        treeId: this.treeId,
                        templateId: this.templateId,
                        processInstanceId: this.processInstanceId
                    });
                } else {
                    formData = await getArchiveTemplateFiles({
                        currentPage: this.currentPage,
                        pageSize: this.pageSize,
                        fileName: this.searchName,
                        treeId: this.treeId,
                        templateId: this.templateId
                    });
                }
                this.formList = formData.data;
                this.fileListLength = formData.data.length;
                // this.currentPage = formData.currentPage;
                // this.pageSize = formData.pageSize;
                // this.totalPageNum = formData.totalPageNum;
                this.loading = false;
            },
            handlePrint () {
                let printObj = [this.$refs['archiveDetail']];
                this.$print(printObj);
            },
            handleFullScreen () {
                this.$emit('handleFullScreen');
            },
            async handleApplyFiles (row) { // 进行归档申请
                // console.log(row);
                this.$confirm(`您确定要对档案目录[ ${row.label} ]下的文件发起归档申请吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let param = {
                        templateId: this.templateId,
                        processInstanceId: this.processInstanceId,
                        archiveFolderIds: row.id
                    };
                    await applyArchiveFile(param);
                    await this._initPage();
                }).catch(() => {});
            },
            async handleAllApplyFiles () { // 进行一键归档申请
                // console.log(row);
                if (this.archiveTemplateTreeList && this.archiveTemplateTreeList.length > 0) {
                    this.$confirm(`您确定要对档案目录[ ${this.archiveTemplateTreeList[0].label} ]下的全部文件发起归档申请吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        let param = {
                            templateId: this.templateId,
                            processInstanceId: this.processInstanceId,
                            archiveFolderIds: this.archiveTemplateTreeList[0].id
                        };
                        await applyArchiveFile(param);
                        await this._initPage();
                    }).catch(() => {});
                } else {
                    this.$message.warning('当前档案目录不存在');
                }
            },
            async handleApprovalFiles (row) {
                this.approvalDialogTile = '档案审核';
                this.isShowApprovalDialog = true;
                this.startProcessloading = false;
                this.approvalInfo.templateId = this.templateId;
                this.approvalInfo.processInstanceId = this.processInstanceId;
                this.approvalInfo.archiveFolderIds = row.id;
                this.approvalInfo.archiveName = row.label;
            },
            handleAllApprovalFiles () {
                // console.log(this.archiveTemplateTreeList);
                if (this.archiveTemplateTreeList && this.archiveTemplateTreeList.length > 0) {
                    this.approvalDialogTile = '一键档案审核';
                    this.isShowApprovalDialog = true;
                    this.startProcessloading = false;
                    this.approvalInfo.templateId = this.templateId;
                    this.approvalInfo.processInstanceId = this.processInstanceId;
                    this.approvalInfo.archiveFolderIds = this.archiveTemplateTreeList[0].id;
                    this.approvalInfo.archiveName = this.archiveTemplateTreeList[0].label;
                } else {
                    this.$message.warning('当前档案目录不存在');
                }
            },
            async handleFinalApproval () {
                let isValid = false;
                this.$refs['approvalInfoForm'].validate((valid) => {
                    if (valid) {
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                });
                if (!isValid) {
                    return false;
                }
                this.startProcessloading = true;
                await approvalArchiveFile(this.approvalInfo);
                await this._initPage();
                this.startProcessloading = false;
                this.isShowApprovalDialog = false;
            },
            async handleMergeFiles () {
                let treeList = await getArchiveTemplateInstanceTreeList({templateId: this.templateId, processInstanceId: this.processInstanceId});
                if (treeList) {
                    this.archiveTemplateInstanceTreeList = treeList;
                }
                // console.log(treeList);
                this.isShowApprovalFilesDialog = true;
            },
            async mergeFiles () { // 进行文件归集
                if (this.mergeFilesDirId === '') {
                    this.$message.warning('请选择需要进行文件归集的档案目录');
                    return;
                }
                this.$confirm(`您确定要对档案目录[ ${this.mergeFilesDirName} ]进行文件归集吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let param = {
                        templateId: this.templateId,
                        processInstanceId: this.processInstanceId,
                        archiveFolderIds: this.mergeFilesDirId
                    };
                    // console.log(param);
                    await mergeArchiveFile(param);
                    await this._initPage();
                    this.isShowApprovalFilesDialog = false;
                }).catch(() => {});
            },
            approvalFilesSelectChoose (selected) {
                if (selected && selected.length > 0 && selected[0] === undefined) {
                    return;
                }
                let ids = [];
                let names = [];
                selected.forEach(item => {
                    ids.push(item.id);
                    names.push(item.label);
                });
                this.mergeFilesDirId = ids.join(',');
                this.mergeFilesDirName = names.join(',');
            },
            async handleSaveArchiveNo () {
                if (this.processInstanceArchiveNo === '') {
                    this.$message.warning('请输入档案编号');
                    return;
                }
                this.$confirm('您确定要修改档案编号吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    await addSaveArchiveNo({processInstanceId: this.processInstanceId, processInstanceArchiveNo: this.processInstanceArchiveNo});
                });
            },
            changeSwitch () {
                // let width=this.isCollapse?'230px':'35px';
                // this.$emit('setMenuWidth', width);
            },
            async handleSearchFile () {
                this.isShowTree = false;
            },
            handleGoArchiveNav () {
                this.navArchiveNav();
            }
        }
    };
</script>

<style lang="less">
  .archive-table{
      .span-line{
          color:rgb(19, 206, 102);
      }
      .span-line:hover{
          text-decoration:underline;
      }
      a{color:#606266}
      a:link {
        color:#606266;
        text-decoration:none;
      }
      a:hover{
        color:#09AAFF;
        text-decoration:none;
      }
      .tools-bar{
            margin: 5px;
      }
      .archiveTemplate {
          margin-top: 5px;
          margin-left: 10px;
          margin-bottom: 5px;
          background: #fff;
      }
      .form-list {
          width: 100%;
      }
      .el-dropdown-link {
        cursor: pointer;
        color: #409eff;
      }
      .show-file-info{
        margin-right: 20px;
        float: right;
        font-size: 12px;
        color: rgb(102, 102, 102);
        font: "12px/1.5 "Microsoft YaHei", arial, SimSun, 宋体;"
      }
      .tools-btn-group{
        margin-top: 1px;
        float: right;
      }
      .print-class {
          float: right;
          // margin-right: 10px;
      }
      .back-class {
          margin-left: 10px;
      }
      .introduce {
        position:absolute;
        // border:1px solid red;
        right:45px;
        top:14px;
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/ArchiveTable/ArchiveTable.vue